import {
  ThemeState,
  FontState,
  CHANGE_THEME,
  CHANGE_FONT,
  CHANGE_DIRECTION,
  DirectionState,
  ConfigurationsActionTypes,
  CHANGE_LARGE_WINDOW,
  LocaleState,
  CHANGE_LOCALE,
  HiddenColumnsState,
  ColumnsOrderState,
  SelectedFiltersState,
  CHANGE_CALENDAR_VIEW
} from './types'
import { CHANGE_HIDDEN_COLUMNS_ALL, CHANGE_SELECTED_FILTERS_ALL, CHANGE_COLUMNS_ORDER_ALL } from "../FlightRequestList/types"


export const changeTheme = (theme: ThemeState): ConfigurationsActionTypes => ({
  type: CHANGE_THEME,
  payload: theme,
});

export const changeDirection = (direction: DirectionState): ConfigurationsActionTypes => ({
  type: CHANGE_DIRECTION,
  payload: direction,
});

export const changeFont = (font: FontState): ConfigurationsActionTypes => ({
  type: CHANGE_FONT,
  payload: font,
});

export const changeLocale = (locale: LocaleState): ConfigurationsActionTypes => ({
  type: CHANGE_LOCALE,
  payload: locale,
});

export const changeHiddenColumns = (hiddenColumns: HiddenColumnsState): ConfigurationsActionTypes => ({
  type: CHANGE_HIDDEN_COLUMNS_ALL,
  payload: { data: hiddenColumns },
});

export const changeColumnsOrder = (columnsOrder: ColumnsOrderState): ConfigurationsActionTypes => ({
  type: CHANGE_COLUMNS_ORDER_ALL,
  payload: { data: columnsOrder },
});

export const changeSelectedFilters = (selectedFilters: SelectedFiltersState): ConfigurationsActionTypes => ({
  type: CHANGE_SELECTED_FILTERS_ALL,
  payload: { data: selectedFilters },
});

export const changeCalendarView = (view: string): ConfigurationsActionTypes => ({
  type: CHANGE_CALENDAR_VIEW,
  payload: { data: view },
});

export const SetLargeWindow = (payload: boolean): ConfigurationsActionTypes => ({
  type: CHANGE_LARGE_WINDOW,
  payload: payload,
});


export const TOGGLE_SIDEBAR = 'RA/TOGGLE_SIDEBAR';
export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR
});
